"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoPlayLists = exports.hasVideoPlayList = exports.isContentContainer = exports.isVideoPlayList = void 0;
var video_lists_1 = require("../../models/content/video-lists");
var content_list_helpers_1 = require("./content-list.helpers");
var content_containers_1 = require("../../models/content/content-containers");
function isVideoPlayList(item) {
    return (item === null || item === void 0 ? void 0 : item.typeDescriptor) === video_lists_1.VideoPlayListKey;
}
exports.isVideoPlayList = isVideoPlayList;
function isContentContainer(item) {
    return (item === null || item === void 0 ? void 0 : item.typeDescriptor) === content_containers_1.ContentContainerKey;
}
exports.isContentContainer = isContentContainer;
function hasVideoPlayList(translation) {
    return getVideoPlayLists(translation).length > 0;
}
exports.hasVideoPlayList = hasVideoPlayList;
function getVideoPlayLists(content) {
    var contentLists = (0, content_list_helpers_1.getContentLists)(content);
    return contentLists.filter(isVideoPlayList);
}
exports.getVideoPlayLists = getVideoPlayLists;
//# sourceMappingURL=video-lists.helpers.js.map